export enum GeneralJournalTemplateDetailType {
NoFilter,
SpecificParent,
SpecificAccount,
}
